module.exports = __webpack_public_path__ + "static/media/admin_plugin_sap_abap.8c4fe000.svg";